import { Box, ListItem, styled, Typography } from '@mui/material';
import { Condition, ConditionMode, useFormState } from '@ngt/forms-core';
import { FC, Fragment, useContext } from 'react';
import { SpeciesFormQuestion as Question } from '../../api/dtos/dtos';
import SpeciesFormsContext from '../../contexts/data/SpeciesFormsContext';
import useFormFieldCondition from '../../hooks/validation/useFormFieldCondition';
import FormFieldComponent from './fields/species-fields/FormFieldComponent';
import MuiMarkdown from 'mui-markdown';

//
// --- Styled Components ---
//
const StyledListItem = styled(ListItem)(() => ({
    display: 'list-item',
    padding: '0',
    paddingLeft: '5px',
    //marginBottom: '15px',
    justifyContent: 'stretch'
}));

const FieldSpacer = styled(Box) (() => ({
    position: 'relative',
    height: '15px'
}));

interface ISpeciesFormQuestionProps {
    speciesFormQuestion: Question;
}

const SpeciesFormQuestion : FC<ISpeciesFormQuestionProps> = ({
    speciesFormQuestion
}) => {
    //
    // -- Hooks --
    const { value } = useFormState({ value: true, errors: true });
    const { getFormFieldDisplayConditions, getOverallFormFieldDisplayConditions } = useFormFieldCondition();

    const recordOfFieldConditions = getFormFieldDisplayConditions(speciesFormQuestion.speciesFormFields);
    const overallCondition = getOverallFormFieldDisplayConditions(speciesFormQuestion.speciesFormFields);
    
    //
    // -- Contexts --
    const { selectedForm } = useContext(SpeciesFormsContext);

    const getQuestionLabel = (label: string) => {
        if (label.endsWith('*')) {
            const blackLabel = label.slice(0, -1);
            const redLabel = '*';
    
            return (
                <Typography mb="8px" display="inline-flex">
                    <MuiMarkdown>{blackLabel + '\u00A0'}</MuiMarkdown>
                    <Box component="span" sx={{ color: 'red' }}>{redLabel}</Box>
                </Typography>
            );
        }
    
        return (
            <Typography mb="8px">
                <MuiMarkdown>{label}</MuiMarkdown>
            </Typography>
        );
    };

    return (
        <Condition
            condition={overallCondition}
            subscription={{ value }}
            mode={ConditionMode.Show}
        >
            <StyledListItem
                key={`question-${speciesFormQuestion.id!}-${speciesFormQuestion.order}`}
            >
                {
                    speciesFormQuestion.label && (
                        getQuestionLabel(speciesFormQuestion.label)
                )}
                {
                    speciesFormQuestion.speciesFormFields?.orderBy('order').map(x => (
                        <Fragment key={`fragment-${x.id}-${x.fieldType}-${x.order}`}>
                            <FormFieldComponent 
                                key={`${x.id}-${x.fieldType}-${x.order}`} 
                                field={x} 
                                form={selectedForm!} 
                                conditionFn={recordOfFieldConditions?.[`${x.id}-${x.fieldType}`]} 
                            />
                            <FieldSpacer />
                        </Fragment>
                    ))
                }
            </StyledListItem>
        </Condition>
    );
}

export default SpeciesFormQuestion